import React from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import { Spinner } from 'react-activity';
import { withTranslation } from 'react-i18next';
import { CampaignAccess } from '@sounditi/ft2-api';

import { setRedirect } from '../../reducers/navigation';
import { showNotification } from '../../reducers/notifications';
import { setTestsData } from '../../reducers/user';

import ModalDialog from '../../components/ModalDialog';
import TopBar from '../../components/TopBar';
import ContentHeader from '../../components/ContentHeader';
import Link from '../../components/Link';
import Input from '../../components/Input';
import T from '../../components/Translate';
import MobileTopBar from '../../components/MobileTopBar';

import { URL_CAMPAIGNS } from '../../config/urls';
import { getURLParameter } from '../../utils/global';

import '../../styles/components/InviteAudience.scss';

const mapStateToProps = (state, ownProps) => ({
  userData: state.user.userData,
  testsData: state.user.testsData,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  setRedirect: val => dispatch(setRedirect(val)),
  setTestsData: val => dispatch(setTestsData(val)),
  showNotification: val => dispatch(showNotification(val)),
  dispatch
})

class InviteAudience extends React.Component {
  _mount = true;

  constructor(props) {
    super(props);
    this.state = {
      campaignData: [],
      testers: [],
      loadingTesters: false,
      loading: true,
      showInviteModal: false,
      loadingModal: false,
      loadingToggle: false,
      loadingStatus: false,
      currentTester: '',
      emailsSendEmail: [
        ''
      ]
    };
  }

  componentWillMount() {
    this.loadData();
  }

  componentDidMount() {

  }

  componentWillUnmount() {
    this._mount = false;
  }

  async loadData() {
    if (this._mount) {
      const { testsData } = this.props;

      const campaignId = getURLParameter("id");
      const campaignData = testsData.filter(test => test.campaignId === campaignId)[0];

      if (!campaignId || !campaignData)
        this.goCampaigns();

      if (campaignData) {
        this.setState({
          campaignData,
          loading: false,
        });

        if (campaignData.testers.length > 0) {
          this.setState({ loadingTesters: true });
        }

        this.refreshTestsData();
      }
    }
  }

  async refreshTestsData() {
    const { setTestsData, dispatch } = this.props;

    try {
      const campaignAccess = new CampaignAccess();
      const refreshedTestsData = await campaignAccess.getCampaigns();

      dispatch(setTestsData(refreshedTestsData));

      const campaignId = getURLParameter("id");
      const campaignData = refreshedTestsData.filter(test => test.campaignId === campaignId)[0];

      this.getTesters(campaignData);
      this.setState({ campaignData });
    } catch (error) { }
  }

  async getTesters(campaignData) {
    const testers = campaignData.testers || [];

    if (testers.length > 0) {
      try {
        const campaignAccess = new CampaignAccess();
        const links = await campaignAccess.getLinks(campaignData.campaignId);

        testers.map(tester => {
          links.filter(link => {
            if (link.email === tester.email) {
              return tester.isActiveLink = link.active;
            }
          });
        });
      } catch (error) { }

      this.setState({ testers, loadingTesters: false });
    }
  }

  goCampaigns() {
    const { setRedirect } = this.props;
    setRedirect({ route: URL_CAMPAIGNS });
  }

  removeItem(key) {
    let newList = this.state.emailsSendEmail;
    newList.splice(key, 1);

    this.setState({emailsSendEmail: newList}, () => {
      newList.map((val,key) => {
        if (this._mount && this.refs[`email${key}`] && this.refs[`email${key}`].refresh) {
          this.refs[`email${key}`].refresh();
        }
      });
    });
  }

  handleChange(val, key) {
    const newEmail = this.state.emailsSendEmail;

    newEmail[key] = val[Object.keys(val)].trim();
    if (this._mount) {
      this.setState({ emailsSendEmail: newEmail });
    }
  }

  checkMailRegex(mail) {
    const r = /(?:[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    return r.test(mail);
  }

  validateEmails() {
    const { emailsSendEmail }= this.state;
    let invalidEmails = [];
    emailsSendEmail.map((email, key) => {
      if (email.trim() === '' || this.checkMailRegex(email) === false) {
        invalidEmails.push('email'+key);
      }
    });

    return invalidEmails;
  }

  addInputEmail() {
    this.setState({
      emailsSendEmail: [...this.state.emailsSendEmail, '']
    })
  }

  async sendEmails() {
    const { showNotification } = this.props;
    const { campaignData, emailsSendEmail } = this.state;
    const invalidEmails = this.validateEmails();

    if (invalidEmails.length > 0) {
      invalidEmails.map( inputName => {
        if (this.refs && this.refs[inputName]) {
          this.refs[inputName].setInvalid();
        }
      });
      showNotification("invalidData");
    } else {
      this.setState({ loadingModal: true });
      try {
        const campaignAccess = new CampaignAccess();
        await campaignAccess.addTestersToCampaign(emailsSendEmail, campaignData.campaignId);
        await this.refreshTestsData();
        showNotification("inviteAudienceSendEmailsSuccesfully");
      } catch (error) {
        showNotification("genericError");
      }
      this.setState({ loadingModal: false, showInviteModal: false, emailsSendEmail: [''] });
    }
  }

  async toggleLink(tester) {
    const { showNotification } = this.props;
    const { campaignData } = this.state;

    this.setState({currentTester: tester.email});
    try {
      this.setState({ loadingToggle: true });

      const campaignAccess = new CampaignAccess();
      const links = await campaignAccess.getLinks(campaignData.campaignId);

      let link = links.filter(link => tester.email === link.email)[0];
      tester.isActiveLink = !link.active;
      link.active = !link.active;

      await campaignAccess.updateLink(link);
      await this.refreshTestsData();

      this.setState({ loadingToggle: false });
    } catch (error) {
      showNotification("genericError");
    }
  }

  async resendLink(email) {
    const { showNotification } = this.props;
    const { campaignData } = this.state;

    this.setState({
      currentTester: email,
      loadingStatus: true
    });

    try {
      const campaignAccess = new CampaignAccess();
      await campaignAccess.reactivateFilmTester(email, campaignData.campaignId);
      await this.refreshTestsData();
    } catch (error) {
      showNotification("genericError");
    }

    this.setState({ loadingStatus: false });
  }

  getFormatDate(inputDate) {
    const date = new Date(inputDate);

    let month = date.getMonth() + 1;
    let day = date.getDate();
    const year = date.getFullYear();

    month = (month < 10 ? "0" : "") + month;
    day = (day < 10 ? "0" : "") + day;

    return `${day}/${month}/${year}`;
  }

  render() {
    const {
      campaignData,
      testers,
      loading,
      loadingTesters,
      showInviteModal,
      loadingModal,
      loadingToggle,
      loadingStatus,
      currentTester,
      emailsSendEmail
    } = this.state;
    const { t, location } = this.props;

    const campaignName = campaignData.data ? campaignData.data.name : "";

    let disableButtonsTable = '';
    if (loadingToggle || loadingStatus) {
      disableButtonsTable = 'disabled';
    }

    const printTestersRows = testers.map( tester => {
      const { email, createdAt, data, isActiveLink } = tester;
      const session = data.sessions[data.sessions.length -1];
      const formattedDate = this.getFormatDate(createdAt);

      let status = 'Sent';
      let statusT = t('InviteAudience_Table_Status_Sent');
      let disableButtonResend = false;
      let disableToggleLink = false;

      if (session.testStarted === true) {
        if (session.testFinished === true) {
          status = 'Finished';
          statusT = t('InviteAudience_Table_Status_Finished');
          disableButtonResend = true;
          disableToggleLink = true;
        } else {
          status = 'Started';
          statusT = t('InviteAudience_Table_Status_Started');
        }
      }

      let toggleClass = `button-toggle`;
      if (isActiveLink) {
        toggleClass = `${toggleClass} active`;
      } else {
        disableButtonResend = true;
      }

      if (disableToggleLink) {
        toggleClass = `${toggleClass} disabled`;
      }

      let loadingRow = '';
      let loadingText = '';
      if ((loadingToggle || loadingStatus) && (currentTester === email)) {
        loadingRow = 'loading-row';
        disableButtonResend = true;

        if (loadingStatus) {
          loadingText = <T text="InviteAudience_Table_Loading_Resending" />
        }

        if (loadingToggle) {
          if (isActiveLink) {
            loadingText = <T text="InviteAudience_Table_Loading_Disabling" />
          } else {
            loadingText = <T text="InviteAudience_Table_Loading_Enabling" />
          }
        }
      }


      return (
        <div key={email} className={`invite-audience-table-row ${loadingRow}`}>
          {(loadingStatus || loadingToggle) && (currentTester === email) && (
              <div className="loading-cover loading-column">
              <div className="loading-column-cover">
                {loadingText}<Spinner speed={0.8} color="#ffffff" size={15} />
              </div>
            </div>
          )}
          <div className="invite-audience-table-cell icon">
            {status === 'Finished'
              ? <i className="icon icon-thumbs-up-1"></i>
              : <i className="icon icon-back-in-time"></i>
            }
          </div>
          <div className="invite-audience-table-cell email">
            <p>{email}</p>
            <p className="date">
              <T text="InviteAudience_Table_Date" var1={formattedDate} />
            </p>
          </div>
          <div className={status === 'Finished' ? 'invite-audience-table-cell finished' : 'invite-audience-table-cell'}>
            {statusT}
          </div>
          <div className="invite-audience-table-cell toggle-link">
          <span className="only-mobile"><T text="InviteAudience_Table_Column3" /></span>
            <div className="btn-icon btn-toggle-media-preview">
              <div className={toggleClass} onClick={ () => this.toggleLink(tester) }>
                <div className="handle"></div>
              </div>
            </div>
          </div>
          <div className="invite-audience-table-cell">
            <Link secondary disabled={disableButtonResend} onClick={() => this.resendLink(email)}>
              <T text="InviteAudience_Button_Reactivate" />
            </Link>
          </div>
        </div>
      );
    });


    return (
      <>
        <ModalDialog
          name="InviteAudience"
          showModal={showInviteModal}
          loading={loadingModal}
          closeModal={e => { this.setState({ showInviteModal: false, emailsSendEmail: [''] }) }}
          onConfirm={e => { this.sendEmails(e) }}
        >
          {emailsSendEmail.map( (email, key) => {
            return (
              <div className="input-email" key={key}>
                <Input
                  placeholder={`user${key+1}@example.com`}
                  name={`email_${key}`}
                  ref={`email${key}`}
                  label={key === 0 ? t('InviteAudience_Modal_Input_Label_Email') : ''}
                  value={this.state.emailsSendEmail[key]}
                  onChange={val => this.handleChange(val, key)}
                />
                {key !== 0 && (
                  <div className="button-close" onClick={() => this.removeItem(key)}>
                    <i className="icon icon-cancel-1"></i>
                  </div>
                )}
              </div>
            );
          })}
          <div className="add-new-tester" onClick={() => this.addInputEmail()}>
            <div className="add-new-tester-icon">
              <i className="icon icon-plus-1"></i>
            </div>
            <div className="add-new-tester-label">
              <T text="InviteAudience_Modal_Button_Add_Email" />
            </div>
          </div>
        </ModalDialog>

        <div className="main-wrapper">
          <TopBar ref="topbar" location={location} />
          <MobileTopBar
            subtitle={campaignName}
            title={t('ContentHeader_Invite_Audience')}
            onClickBackButton={() => this.refs.topbar.goTests()}
          />
          <div className="fluid screen-content">
            <ContentHeader
              location={location}
              campaignData={campaignData}
            />
            <div className="content-wrapper">
              {loading && (
                <div className="loading-cover">
                  <div>
                    <Spinner speed={0.8} color="#00C7E7" size={20} />
                  </div>
                </div>
              )}
              {!loading && (
                <div id="invite-audience">
                  <div className="invite-audience-header">
                    <h2><T text="InviteAudience_Title" /></h2>
                    <Link main className="only-desktop" onClick={() => this.setState({showInviteModal: true})}>
                      <i className="icon icon-plus-1"></i><T text="InviteAudience_Button_Add" />
                    </Link>
                  </div>
                  <p className="invite-audience-description"><T text="InviteAudience_Description" /></p>
                  <div className="invite-audience-users">
                    {loadingTesters && (
                      <div className="loading-cover">
                        <div>
                          <Spinner speed={0.8} color="#00C7E7" size={20} />
                        </div>
                      </div>
                    )}
                    {!loadingTesters && testers.length > 0 && (
                      <div className={`invite-audience-table ${disableButtonsTable}`}>
                        <div className="invite-audience-table-head">
                          <div className="invite-audience-table-head-cell"></div>
                          <div className="invite-audience-table-head-cell email"><T text="InviteAudience_Table_Column1" /></div>
                          <div className="invite-audience-table-head-cell"><T text="InviteAudience_Table_Column2" /></div>
                          <div className="invite-audience-table-head-cell only-desktop"><T text="InviteAudience_Table_Column3" /></div>
                          <div className="invite-audience-table-head-cell only-desktop"></div>
                        </div>
                        {printTestersRows}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="fixed-bottom float-bottom only-mobile">
            <Link main className="full-width" onClick={() => this.setState({showInviteModal: true})}>
              <i className="icon icon-plus-1"></i><T text="InviteAudience_Button_Add" />
            </Link>
          </div>
        </div>
      </>
    );
  }
}

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(InviteAudience);
